import { Answer } from '../Answer/Answer'
import { PrebuildType } from '../Element'
import { Survey, SurveyContext } from '../Survey'
import { Analysis } from './Analysis'
import { BueroType, Values } from './Calculation'
import { BueroTypeResult, ResultPropsUebergeordneteBedarfe } from './FactorValues'

export enum OptimizationMode {
  STANDARD = 'STANDARD',
  MIN = 'MIN',
  MAX = 'MAX',
  MIX = 'MIX',
}

export enum ModuleSizes {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export type Optimization = {
  verkehrsflaechenPercentage?: number
  [PrebuildType.UEBERGEORDNETE_BEDARFE]: ResultPropsUebergeordneteBedarfe[]
}

export type ConceptValues = Values & { bueroType: BueroType }

export type ConceptUnitList = {
  [unitUUID: string]: ConceptValues
} & { sum?: BueroTypeResult }

export enum FloorMappingEntryType {
  UNIT = 'UNIT',
  UEBERGEORDNETER_BEDARF = 'UEBERGEORDNETER_BEDARF',
}

export type FloorMappingEntry = {
  type: FloorMappingEntryType
  floorUUID: string
  targetUUID?: string
}

export type Concept = {
  uuid?: string
  index?: number
  surveyContextUUID?: string
  name?: string
  floorMapping?: FloorMappingEntry[]
  units?: ConceptUnitList
  optimization?: Optimization
  createdOn?: Date
}

export type ConceptConfiguration = {
  context: SurveyContext
  concepts: Concept[]
  graphConceptUUIDList: string[]
  activeConceptUUID: string
  teamSurvey: Survey
  managerSurvey: Survey
  leaderSurvey: Survey
  loading: boolean
}

export type ConceptDataCluster = {
  globalAnalysis: Analysis
  allTeamAnalysis: Analysis[]
  allManagerAnswers: Answer[]
  leaderAnswer: Answer
  teamSurvey: Survey
  managerSurvey: Survey
  leaderSurvey: Survey
}
